import { Container } from './ToolTipStyles';

const ToolTip = ({ label, isOpen = false, anchorEl, sx }) => {
  if (!Boolean(anchorEl)) return;

  const { bottom, hieght, left, right, top, width, x, y } = anchorEl.getBoundingClientRect();

  return (
    <Container isOpen={isOpen} y={y + 30} x={x} style={{ ...sx }}>
      <div className="text-white text-xs px-1">{label}</div>
    </Container>
  );
};

export default ToolTip;
